import Icon from '@/components/snippets/icon/icon'
import { FilterDrawer } from 'libs/searchspring/components/collection/filters/FilterDrawer'
import { useFilters } from 'libs/searchspring/hooks/useFilters'

export const CollectionToolbar = () => {
  const { activeFilters } = useFilters()
  const title = window.collection?.title || ''
  const descriptionHtml = window.collection?.description_html || ''
  const showDescription = window.settings?.show_description !== false
  const showDesc = showDescription && descriptionHtml
  const showFilters = !!window.settings?.show_filters
  const filterLabel =
    activeFilters.size > 0 ? `Filter & Sort (${activeFilters.size})` : 'Filter & Sort'

  return (
    <div className="collection-toolbar flex sticky top-header-adapt left-0 w-full z-40 transition-all">
      <div className="grid grid-cols-full-min lg:grid-cols-max-full-min items-center gap-x-1 w-full min-h-[56px] lg:min-h-[55px] bg-secondary px-margin border-b border-borders-default">
        {title && (
          <div className="col-[1/2] py-1">
            <h2 className="paragraph-m font-serif italic">{title}</h2>
          </div>
        )}
        {showDesc && (
          <div className="collection-toolbar__description col-span-full lg:col-[2/3] w-full lg:max-w-[600px] max-h-view lg-max:container-full overflow-hidden transition-all">
            <div className="w-full lg-max:container-full py-1 lg-max:border-t border-borders-default">
              <div
                className="w-full lg:pl-1 lg:border-l lg:border-borders-default"
                dangerouslySetInnerHTML={{
                  __html: `<read-more class="richtext link-underline paragraph-xs font-serif italic w-full h-fit" data-limit="85" data-btn-loadmore-class="text-line text-line-large link-fade">${descriptionHtml}</read-more>`
                }}
              />
            </div>
          </div>
        )}
        <div className="shrink-0 col-[2/3] lg:col-[3/4] lg-max:row-[1] lg:self-end flex lg:items-end lg:justify-end py-0.25">
          <button
            className="btn btn-text btn-primary btn-m w-fit whitespace-nowrap"
            data-modal-parent="filters"
            data-modal-role="toggle"
            aria-label={filterLabel}
          >
            <span>{filterLabel}</span>
            <div className="filter-button__icons shrink-0 flex">
              <div className="flex size-[11px] children:size-full children:object-contain">
                <Icon id="plus" />
              </div>
              <div className="hidden size-[11px] children:size-full children:object-contain">
                <Icon id="minus" />
              </div>
            </div>
          </button>
        </div>
      </div>
      <FilterDrawer showFilters={showFilters} />
    </div>
  )
}
